import {
  START_FETCHING_PRINT_RECORD_SHARING_STATUS,
  RECEIVED_PRINT_RECORD_SHARING_STATUS,
  START_TOGGLE_PRINT_RECORD_SHARING,
  TOGGLE_PRINT_RECORD_SHARING_SUCCESSFULLY,
  TOGGLE_PRINT_RECORD_SHARING_FAILED
} from "../actions/types";
import axios from 'axios';
import { backendDomain } from "../modules/configs";
import { PRINT_RECORD_SHARING_STATUS } from "../containers/account-setting-container";

export const startFetchingPrintRecordSharingStatus = () => dispatch => {
  dispatch({ type: START_FETCHING_PRINT_RECORD_SHARING_STATUS })
  axios.post(`${backendDomain}/preference/getShareStatus`, { idToken: localStorage.getItem('id_token') }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
  })
    .then(res => {
      if (res.status === 200) {
        const { currentStatus } = res.data;
        dispatch(receivedPrintRecordSharingStatus(currentStatus))
      }
    })
    .catch(err => {
      console.log(err);
    })
};

const receivedPrintRecordSharingStatus = (currentStatus) => ({
  type: RECEIVED_PRINT_RECORD_SHARING_STATUS,
  payload: { printRecordSharingStatus: currentStatus }
});

export const startTogglePrintRecordSharing = (currentStatus) => dispatch => {
  dispatch({ type: START_TOGGLE_PRINT_RECORD_SHARING });
  const urlSuffix = currentStatus === PRINT_RECORD_SHARING_STATUS.ON ? 'unShare' : 'share';
  const url = `${backendDomain}/preference/${urlSuffix}`;
  axios.post(url, { idToken: localStorage.getItem('id_token') }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`
    }
  })
    .then(res => {
      if (res.status === 201) {
        const newStatus = res.data.currentStatus;
        dispatch(togglePrintRecordSharingSuccess(newStatus));
      }
    })
    .catch(err => {
      console.log(err);
      dispatch(togglePrintRecordSharingFail());
    })
};

const togglePrintRecordSharingSuccess = (printRecordSharingStatus) => ({
  type: TOGGLE_PRINT_RECORD_SHARING_SUCCESSFULLY,
  payload: { printRecordSharingStatus }
});

const togglePrintRecordSharingFail = () => ({
  type: TOGGLE_PRINT_RECORD_SHARING_FAILED
});



// WEBPACK FOOTER //
// ./src/actions/getPrintRecordSharingStatus.js